import SngHockLin from "../Assets/SngHockLin.png";
import * as React from "react";
import Modal from "@mui/material/Modal";
import CloseIcon from "@mui/icons-material/Close";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

function Card() {
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <div className="card">
      <div>
        <img
          className="card-img-style"
          src={SngHockLin}
          alt="judge picture"
        ></img>
      </div>

      <div className="card-text-style">
        <h2 className="card-name-style">Sng Hock Lin</h2>
        <p className="card-sub-name-style">
          Gerontological Leader,
          <br /> Former Chief of Silver Generation Office
        </p>
        <br />

        <button className="readmore-button" onClick={handleOpen}>
          Read More
        </button>
        <Modal
          className="close-button"
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div className="popup-style">
            <CloseIcon className="close-icon" onClick={handleClose} />
            <h2>Sng Hock Lin</h2>
            <h3>
              Gerontological Leader, Former Chief of Silver Generation Office
            </h3>

            <br />
            <p>
              Dr Sng Hock Lin is a Gerontological Leader and former Chief of
              Silver Generation Office, the outreach arm of the Agency for
              Integrated Care in Singapore that focuses on older adults
              engagement. The Agency has a dedicated pool of passionate
              volunteers who encourages older adults to live actively and
              support those with needs or risk factors. A leading advocate for
              active living and successful ageing, Hock Lin holds a PHD in
              Gerontology from the Singapore University of Social Sciences and
              his area of interests include active ageing, citizen-centric
              services, leadership and organisation transformation. In his role,
              Hock Lin is also driving volunteerism as a national cause to
              empower seniors to take charge of their own well-being, inspiring
              community care efforts across the country to ensure their seniors
              live well and age gracefully.
              <br />
              <br />
            </p>
          </div>
        </Modal>
      </div>

      <div></div>
    </div>
  );
}

export default Card;
